import { AnimationMixer, Mesh, Vector3 } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { GUI } from "dat.gui";

import GLB_Andatti from "../../../assets/models/charactersoxxo/GLB_Andatti_V7.glb";
import GLB_Cel from "../../../assets/models/charactersoxxo/GLB_CEL_V6_3.glb";
import GLB_Premia from "../../../assets/models/charactersoxxo/GLB_Premia_V7.glb";
import GLB_Spin from "../../../assets/models/charactersoxxo/GLB_Spin_V7.glb";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";

export class CharcterOxxo extends Mesh {
	constructor(loadingManager, textModel, position, rotation, scale = 0.2) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		this.name = `charc-${textModel}`;
		loader.setDRACOLoader(dracoloader);
		this.position.set(position.x, position.y, position.z);
		this.rotation.set(rotation.x, rotation.y, rotation.z);
		this.characterId = textModel;
		let model = GLB_Andatti;
		switch (textModel) {
			case 1:
				model = GLB_Andatti;
				break;
			case 2:
				model = GLB_Cel;
				break;
			case 3:
				model = GLB_Premia;
				break;
			case 4:
				model = GLB_Spin;
				break;
			default:
				model = GLB_Andatti;
				break;
		}
		this.onLoadModels(loader, model);
		this.mixer = null;

		this.scale.set(scale, scale, scale);
		this.observerListeners();
		// this.helpers();
	}

	onLoadModels(loader, model) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.MarcadorAndatti = gltf.scene.getObjectByName("MarcadorAndatti", true); // 1
			this.FBX_AndattiArmANDATTI = gltf.scene.getObjectByName("FBX_AndattiArmANDATTI", true); // 1

			this.MarcadorCel = gltf.scene.getObjectByName("MarcadorCel", true); //  2
			this.Cel_MainBody = gltf.scene.getObjectByName("Cel_MainBody", true); //  2

			this.MarcadoPremia = gltf.scene.getObjectByName("MarcadoPremia", true); //  3
			this.FBX_PremiaArmPREMIA = gltf.scene.getObjectByName("FBX_PremiaArmPREMIA", true); //  3

			this.MarcadorSpin = gltf.scene.getObjectByName("MarcadorSpin", true); //  4
			this.FBX_SpinBrowsSPIN = gltf.scene.getObjectByName("FBX_SpinBrowsSPIN", true); //  4


			// 1
			if (this.MarcadorAndatti !== undefined) {
				this.MarcadorAndatti.visible = false;
			}

			if (this.FBX_AndattiArmANDATTI !== undefined) {
				this.FBX_AndattiArmANDATTI.material.emissiveIntensity = 4.4;
				this.FBX_AndattiArmANDATTI.material.emissive.set("#777777");
			}

			//2

			if (this.MarcadorCel !== undefined) {
				this.MarcadorCel.visible = false;
				this.MarcadorCel.material.emissive.set("#595959");
			}

			// 3
			if (this.MarcadoPremia !== undefined) {
				this.MarcadoPremia.visible = false;
			}

			if (this.FBX_PremiaArmPREMIA !== undefined) {
				this.FBX_PremiaArmPREMIA.material.emissiveIntensity = 2.6;
				this.FBX_PremiaArmPREMIA.material.emissive.set("#727272");
			}

			// 4

			if (this.MarcadorSpin !== undefined) {
				this.MarcadorSpin.visible = false;
			}

			if (this.FBX_SpinBrowsSPIN !== undefined) {
				this.FBX_SpinBrowsSPIN.material.emissiveIntensity = 1.52;
				this.FBX_SpinBrowsSPIN.material.emissive.set("#C7C7C7");
			}

			this.onChangueConfig();

			const animations = gltf.animations;
			if (animations && animations.length) {
				this.mixer = new AnimationMixer(gltf.scene);
				this.idle = animations.find((anim) => anim.name === "Idle 1");
				this.idle2 = animations.find((anim) => anim.name === "Idle 2");
				this.saludo = animations.find((anim) => anim.name === "Saludo");
				this.festejo = animations.find((anim) => anim.name === "Festejo");
				this.pena = animations.find((anim) => anim.name === "Pena");
				this.pensativo = animations.find((anim) => anim.name === "Pensativo");

				this.mixer.clipAction(this.idle).play(); // Reproducir la primera animación
			}
			// this.position.set(-28, -7, 7.1);
			// this.rotation.set(0, 1.4, 0);
		});
	}

	onChangueConfig() {
		this.scale.set(0.10, 0.10, 0.10); // 1
	}

	onAnimateIdle() {
		this.mixer.stopAllAction();
		this.mixer.clipAction(this.idle).play();
	}
	onAnimateIdleTwo() {
		this.mixer.stopAllAction();
		this.mixer.clipAction(this.idle2).play();
	}
	onAnimateSaludo() {
		this.mixer.stopAllAction();
		this.mixer.clipAction(this.saludo).play();
	}
	onAnimationFestejo() {
		this.mixer.stopAllAction();
		this.mixer.clipAction(this.festejo).play();
	}
	onAnimationPena() {
		this.mixer.stopAllAction();
		this.mixer.clipAction(this.pena).play();
	}
	onAnimationPensativo() {
		this.mixer.stopAllAction();
		this.mixer.clipAction(this.pensativo).play();
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.characterAnimations.hiddenModel, () => {
			this.visible = false;
		});
		ObserverEmitter.on(EVENTS.characterAnimations.showModel, () => {
			this.visible = true;
		});
		ObserverEmitter.on(EVENTS.characterAnimations.festejo, () => {
			this.visible = true;
			this.onAnimationFestejo();
		});
		ObserverEmitter.on(EVENTS.characterAnimations.idle, () => {
			this.visible = true;
			this.onAnimateIdle();
		});
		ObserverEmitter.on(EVENTS.characterAnimations.idle2, () => {
			this.visible = true;
			this.onAnimateIdleTwo();
		});
		ObserverEmitter.on(EVENTS.characterAnimations.pena, () => {
			this.visible = true;
			this.onAnimationPena();
		});
		ObserverEmitter.on(EVENTS.characterAnimations.pensativo, () => {
			this.visible = true;
			this.onAnimationPensativo();
		});
		ObserverEmitter.on(EVENTS.characterAnimations.saludo, () => {
			this.visible = true;
			this.onAnimateSaludo();
		});
	}

	helpers(limitPosition = 500, limitRotation = 5) {
		const gui = new GUI();
		const premiaFolder = gui.addFolder(this.name);
		premiaFolder.add(this.position, "x", -limitPosition, limitPosition).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -limitPosition, limitPosition).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -limitPosition, limitPosition).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -limitRotation, limitRotation).step(0.0001).name("Rotacion X");
		premiaFolder.add(this.rotation, "y", -limitRotation, limitRotation).step(0.0001).name("Rotacion Y");
		premiaFolder.add(this.rotation, "z", -limitRotation, limitRotation).step(0.0001).name("Rotacion Z");
		premiaFolder.add(this.scale, "x", 0, 4).step(0.01).name("Escala X");
		premiaFolder.add(this.scale, "y", 0, 4).step(0.01).name("Escala Y");
		premiaFolder.add(this.scale, "z", 0, 4).step(0.01).name("Escala Z");
		premiaFolder.add(this, "visible").name("Visible");

	}

	helpersChild(object = null, limitPosition = 500, limitRotation = 5) {
		if (!object) {
			return
		}
		const object3D = object
		const gui = new GUI();
		const premiaFolder = gui.addFolder(object3D.name);
		premiaFolder.add(object3D.position, "x", -limitPosition, limitPosition).step(0.0001).name("Posición X");
		premiaFolder.add(object3D.position, "y", -limitPosition, limitPosition).step(0.0001).name("Posición Y");
		premiaFolder.add(object3D.position, "z", -limitPosition, limitPosition).step(0.0001).name("Posición Z");
		premiaFolder.add(object3D.rotation, "x", -limitRotation, limitRotation).step(0.0001).name("Rotacion X");
		premiaFolder.add(object3D.rotation, "y", -limitRotation, limitRotation).step(0.0001).name("Rotacion Y");
		premiaFolder.add(object3D.rotation, "z", -limitRotation, limitRotation).step(0.0001).name("Rotacion Z");
		premiaFolder.add(object3D.scale, "x", 0, 4).step(0.01).name("Escala X");
		premiaFolder.add(object3D.scale, "y", 0, 4).step(0.01).name("Escala Y");
		premiaFolder.add(object3D.scale, "z", 0, 4).step(0.01).name("Escala Z");
		premiaFolder.add(object3D, "visible").name("Visible");

	}

	helperlight(name = "", objectId = -1) {
		if (objectId === undefined) {
			console.log("sin object");
			return;
		}
		let object = null;

		switch (this.characterId) {
			case 1:
				object = this.FBX_AndattiArmANDATTI;
				break;
			case 2:
				object = null;
				break;
			case 3:
				object = this.FBX_PremiaArmPREMIA;
				break;
			case 4:
				object = this.FBX_SpinBrowsSPIN;
				break;
			default:
				object = null;
				break;
		}

		if (object === null) {
			console.log("vacio");
			return;
		}

		const gui = new GUI();
		const folder = gui.addFolder(name);
		folder
			.addColor({ color: object.material.color.getHex() }, "color")
			.name("Color del Material")
			.onChange((value) => {
				object.material.color.set(value);
			});

		folder
			.add(object.material, "emissiveIntensity", 0, 10)
			.name("Intensidad de Emisión")
			.onChange(function (intensity) {
				object.material.emissiveIntensity = intensity;
			});

		const emissiveControl = folder.addColor({ emissive: object.material.emissive.getHex() }, "emissive").name("Color de Emisión");
		emissiveControl.onChange(function (color) {
			object.material.emissive.set(color);
		});
	}

	onPositionCharacterInFront(camera) {
		const direccionMira = new Vector3();
		camera.getWorldDirection(direccionMira);
		const vectorDesplazamiento = direccionMira.multiplyScalar(2);
		vectorDesplazamiento.y -= 0.2;
		this.position.copy(camera.position).add(vectorDesplazamiento);
	}

	renderAnimations(delta, camera) {
		if (camera) {
			this.lookAt(camera.position);
			this.onPositionCharacterInFront(camera);
		}
		if (this.mixer) {
			this.mixer.update(delta);
		}
	}
}
